import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { PlaceSelectors } from '@app/entities/place';
import { TravelDetailProvider } from '@shared/bus-itinerary/entities/bus-detail-provider';
import { TranslatePipe } from '@app/translate/TranslatePipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';

@Component({
  selector: 'app-bus-info',
  templateUrl: './bus-info.component.html',
  styleUrls: ['./bus-info.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BusInfoComponent {

  @Input() isMobile: boolean = false;
  @Input() companyCode: string;
  @Input() busClass: string;
  @Input() departureDate: string;
  @Input() bus: string;
  @Input() departureTerminal: string;
  @Input() arrivalDate: string;
  @Input() arrivalTerminal: string;
  @Input() opTerminalCode: string;
  @Input() number: number;
  @Input() busTimeInternal: string;
  @Input() travelInfoProvider: TravelDetailProvider = TravelDetailProvider.BUS_RESULTS;

  public placeCriteria: string = PlaceSelectors.City;

  constructor(
    private translatePipe: TranslatePipe,
    private placeNamePipe: PlaceNamePipe
  ) { }

  get noShadow(): boolean {
    return this.showOnlyInDesktopBooking || this.isUserHistory;
  }

  get isBooking(): boolean {
    return this.travelInfoProvider === TravelDetailProvider.BOOKING_BUSES;
  }

  get isUserHistory(): boolean {
    return this.travelInfoProvider === TravelDetailProvider.USER_HISTORY || this.isUserBusHistory;
  }

  get showTimeLines(): boolean {
    return this.isUserBusHistory || !this.showOnlyInDesktopBooking;
  }

  get showOnlyInDesktopBooking(): boolean {
    return this.isBooking && !this.isMobile;
  }

  get isOperatedByAnotherAirline(): boolean {
    return (!!this.companyCode && !!this.opTerminalCode) && this.companyCode !== this.opTerminalCode;
  }

  get isUserBusHistory(): boolean {
    return this.travelInfoProvider === TravelDetailProvider.USER_HISTORY_BUSES;
  }

  get busClassText(): string {
    return this.translatePipe.transform(`BUS_RESULTS_MODULE.FLIGHT_CLASSES.${this.busClass}`);
  }

  get departureTerminalCity$(): Observable<string> {
    return this.placeNamePipe.transform(this.departureTerminal, PlaceSelectors.City, true);
  }

  get arrivalTerminalCity$(): Observable<string> {
    return this.placeNamePipe.transform(this.arrivalTerminal, PlaceSelectors.City, true);
  }
}
